import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { MenteeGroupData } from '../../providers/mentee-group-data'
import { ViewMenteeSadhanaPage } from '../view-mentee-sadhana/view-mentee-sadhana'
import { GlobalVariable } from '../../global'
import { HomePage } from '../home/home';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the ViewMyMenteesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-view-my-mentees',
  templateUrl: 'view-my-mentees.html',
})
export class ViewMyMenteesPage {
  mentees: any
  usertype: any;
  constructor(public navCtrl: NavController, public alertCtrl: AlertController, public navParams: NavParams,
    public menteeGroupData: MenteeGroupData, private storage: Storage) {
    this.storage.get('usertype').then((value) => {
      this.usertype = value;
      if (this.usertype != GlobalVariable.Mentor) {
        this.navCtrl.setRoot(HomePage);
      }
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewMyMenteesPage');
    this.getMenteeList()
  }

  getMenteeList() {
    this.menteeGroupData.getMenteeByMentor().subscribe(
      res => {
        if (res['success']) {
          this.mentees = res['data']
          this.mentees.map(item => {
            if (item.sadhanasummary >= GlobalVariable.GREEN) {
              item.color = 'primary'
            } else if (item.sadhanasummary == GlobalVariable.RED) {
              item.color = 'danger'
            } else {
              item.color = 'orange'
            }
          })
        }
      }
    )
  }

  onClickOnView(item) {

    this.navCtrl.push(ViewMenteeSadhanaPage, {
      menteeuserid: item.userid,
      menteeusername: item.surname + ' ' + item.forename,
      activityname: item.color
    })
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-my-mentees/view-my-mentees.ts